import React, { Component } from "react";
import { Carousel } from "react-bootstrap";
import styled from "styled-components";

import steamFortress1 from "../library/images/steamfortress_01.jpg";
import steamFortress2 from "../library/images/steamfortress_02.jpg";
import steamFortress3 from "../library/images/steamfortress_03.jpg";

export class MapCarousel extends Component {
  render() {
    return (
      <CarouselWrapper>
        <Carousel indicators={false} style={{ height: "100%", width: "100%" }}>
          <Carousel.Item>
            <img src={steamFortress1} alt="Steam Fortress 1" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={steamFortress2} alt="Steam Fortress 2" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={steamFortress3} alt="Steam Fortress 3" />
          </Carousel.Item>
        </Carousel>
      </CarouselWrapper>
    );
  }
}

const CarouselWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20vw 20px 20vw;

  img {
    height: 100%;
    width: 100%;
    border: solid;
    border-width: 2px;
    border-color: #ffcb02;
  }

  @media (max-width: 800px) {
    padding: 10px 10vw 20px 10vw;
  }

  @media (max-width: 650px) {
    padding: 10px 5vw 20px 5vw;
  }
`;

export default MapCarousel;
